module.exports = __webpack_public_path__ + "static/Fernando-47c55b5220011d53f6f37536993cc354.png";